import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const RevealMeetingPrepCardOnceMutation = graphql(`
  mutation RevealMeetingPrepCardOnce($input: RevealMeetingPrepCardInput!) {
    revealMeetingPrepCardOnce(input: $input) {
      id
      __typename
      clientId
      prepSessionId
      cardKey
    }
  }
`);

export interface RevealMeetingPrepCardInput {
  clientId: string;
  prepSessionId: string;
  cardKey: string;
}

export function useRevealMeetingPrepCardOnce() {
  const [result, revealMeetingPrepCardOnceMutation] = useMutation(RevealMeetingPrepCardOnceMutation);
  const [error, setError] = useState<Error | null>(null);

  const revealMeetingPrepCardOnce = useCallback(
    async (input: RevealMeetingPrepCardInput) => {
      try {
        const response = await revealMeetingPrepCardOnceMutation({ input });
        if (response.error) {
          throw response.error;
        }
        setError(null);
        return response.data?.revealMeetingPrepCardOnce;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [revealMeetingPrepCardOnceMutation],
  );

  return { revealMeetingPrepCardOnce, result, error };
}
